import QuestionmarkDiamondFill from './QuestionmarkDiamondFill';

export default QuestionmarkDiamondFill;
